/**
 * Message is an actual message received from the vchat server.
 * @TODO Why does this not contain a message ID?
 * @TODO Check whether the Message class is used anywhere? 
 * Might it be deprecated?
 */
export class Message {
	constructor(date, from, text) {
		this.date = date;
		this.from = from;
		this.text = text;
	}
}

window.ReceivedChatMessage = function(date, from, text) {
	let m = new Message(date, from, text);
	document.dispatchEvent(new CustomEvent(`chat-message`, { bubbles: true, detail: m }));
}